import type { ComponentProps } from "react"
import { forwardRef } from "react"

export const IssuesAmountIcon = forwardRef<
	SVGSVGElement,
	ComponentProps<"svg">
>(({ className, ...props }, ref) => (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.5 1.16671C3.5 0.844541 3.76117 0.583374 4.08333 0.583374H9.91667C10.2388 0.583374 10.5 0.844541 10.5 1.16671C10.5 1.48887 10.2388 1.75004 9.91667 1.75004H4.08333C3.76117 1.75004 3.5 1.48887 3.5 1.16671Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.33337 3.49996C2.33337 3.17779 2.59454 2.91663 2.91671 2.91663H11.0834C11.4055 2.91663 11.6667 3.17779 11.6667 3.49996C11.6667 3.82213 11.4055 4.08329 11.0834 4.08329H2.91671C2.59454 4.08329 2.33337 3.82213 2.33337 3.49996Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.91663 6.41667C2.59446 6.41667 2.33329 6.67783 2.33329 7V11.6667C2.33329 11.9888 2.59446 12.25 2.91663 12.25H11.0833C11.4055 12.25 11.6666 11.9888 11.6666 11.6667V7C11.6666 6.67783 11.4055 6.41667 11.0833 6.41667H2.91663ZM1.16663 7C1.16663 6.0335 1.95013 5.25 2.91663 5.25H11.0833C12.0498 5.25 12.8333 6.0335 12.8333 7V11.6667C12.8333 12.6332 12.0498 13.4167 11.0833 13.4167H2.91663C1.95013 13.4167 1.16663 12.6332 1.16663 11.6667V7Z"
			fill="currentColor"
		/>
	</svg>
))
